import Organization from "./Organization";
import {ResourceOwnerType} from "./ResourceOwnerType";

export enum AiProviderConnectionType {
    OPENAI_COMPATIBLE_API = "OPENAI_COMPATIBLE_API"
}

export function formatAiProviderConnectionType(type?: AiProviderConnectionType) {
    switch (type) {
        case AiProviderConnectionType.OPENAI_COMPATIBLE_API:
            return "OpenAI-compatible API";
        default:
            return type;
    }
}

class AiProviderConnection {
    constructor(
        public id?: string,
        public createdAt?: Date,
        public name?: string,
        public description?: string,
        public type?: AiProviderConnectionType,
        public baseUrl?: string,
        public apiKey?: string,
        public owner?: ResourceOwnerType,
        public organization?: Organization
    ) {
    }

    public static fromPOJO(data: any) {
        if (!data) {
            return null;
        }

        const entity = new AiProviderConnection();

        entity.id = data.id;
        entity.createdAt = data.createdAt;
        entity.name = data.name;
        entity.description = data.description;
        entity.type = data.type;
        entity.baseUrl = data.baseUrl;
        entity.apiKey = data.apiKey;
        entity.owner = data.owner;
        entity.organization = data.organization ? Organization.fromPOJO(data.organization) : undefined;

        return entity;
    }
}

export default AiProviderConnection;
